import { render, staticRenderFns } from "./workDesc.vue?vue&type=template&id=f055ac96&scoped=true"
import script from "./workDesc.vue?vue&type=script&lang=js"
export * from "./workDesc.vue?vue&type=script&lang=js"
import style0 from "./workDesc.vue?vue&type=style&index=0&id=f055ac96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f055ac96",
  null
  
)

export default component.exports